export enum PlatformType {
    Undefined = 0,
    PresentAndConnect = 1,
    ThirdParty = 2,
    Zoom = 3
}
